import { render, staticRenderFns } from "./RightMenuTree.vue?vue&type=template&id=54133109&scoped=true"
import script from "./RightMenuTree.vue?vue&type=script&lang=js"
export * from "./RightMenuTree.vue?vue&type=script&lang=js"
import style0 from "./RightMenuTree.vue?vue&type=style&index=0&id=54133109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54133109",
  null
  
)

export default component.exports